import { Component, DestroyRef, HostListener, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { TradeFacade } from '@zero/trade/domain';
import { filter } from 'rxjs';

@Component({
  imports: [TranslocoPipe, ButtonComponent, ModalComponent],
  templateUrl: './multi-order-consent.component.html',
})
export class MultiOrderConsentComponent {
  @Input() public type: 'order' | 'savingsPlan' = 'order';

  public readonly activeModal = inject(NgbActiveModal);
  readonly #facade = inject(TradeFacade);
  readonly #destroyRef = inject(DestroyRef);

  public confirm(): void {
    this.#facade.confirmMultiOrderConsent();
    this.#facade.multiOrderConsentConfirmed$
      .pipe(
        filter((confirmed) => !!confirmed),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.activeModal.close(false));
  }

  @HostListener('window:popstate', ['$event'])
  public onPopState() {
    this.activeModal.close(false);
  }
}
